import { Injectable } from "@angular/core";
import { Adapter } from "@core/adapter";

export interface OrganisationSubscription {
  id: string;
  startDate: Date;
  expirationDate:Date;
  referralId:string;
  referralName:string;
  isTrial:boolean;
  isAutoRenew:boolean;
  isAutomaticallyGranted:boolean;
  expired:boolean;
  price:number;
  discount:number;
  discountedPrice:number;
  canInvite:boolean;
  packageId:string;
  packageName:string;
  packagePosition:number;
  packageCategoryId:string;
  packageCategoryPosition:number;
  packagePriceId:string;
  onRequest:boolean;
}


@Injectable({
  providedIn: 'root'
})

export class OrganisationSubscriptionAdapter implements Adapter<OrganisationSubscription> {
  adapt(s:any){
    const discount = s.referral? (s.referral.discount??0):0;
    const sp = s.subscriptionPackagePrice;
    const price = sp? (sp.isTrial?0: (sp.monthlyPrice??0) * 12):0;
    const now = new Date();
        
    return { 
      id: s.id, 
      startDate: s.startDate, 
      expirationDate:s.expirationDate, 
      referralId:s.referral ? s.referral.id:'', 
      referralName:s.referral? s.referral.title:'', 
      isAutoRenew:s.isAutoRenew, 
      isTrial:s.isTrial,
      isAutomaticallyGranted:s.isAutomaticallyGranted ?? false,
      price:price,
      discount:discount,
      discountedPrice: price - discount,
      expired:(new Date(s.expirationDate) < now),
      canInvite:true,
      packageId:sp ? sp.package.id??'':'',
      packageName:sp ? sp.package.name??'':'',
      packagePosition:sp ? sp.package.position??0:0,
      packageCategoryId:sp ? sp.subscriptionCategory.id??'':'',
      packageCategoryPosition:sp ? sp.subscriptionCategory.position??0:0,
      packagePriceId:sp ? sp.id??'':'',
      onRequest: sp.monthlyPrice == null
    } as OrganisationSubscription
  }
}
